<template>
  <section>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(verifyDocument)">
        <!-- Box de Formulario HouseholdAllowance -->
        <div class="modal-card" style="width: auto" id="modal-distance-person-function">
          <header class="modal-card-head">
            <p class="modal-card-title">{{modalHeader}}</p>
            <button
                type="button"
                class="delete"
                @click="$emit('close')"/>
          </header>
          <section class="modal-card-body" id="modal-distance-person-function" ref="modalDistancePersonFunction">
            <div class="columns">
              <div class="column">
                <div class="mb-2" v-if="Object.keys(errores_validacion).length !== 0">
                  <b-message type="is-danger" has-icon>
                    <div v-for="(item,index) in errores_validacion" :key='index'>
                      {{ item[0] }}
                    </div>
                  </b-message>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="Descripción*">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <b-input v-model="person_function.description" type="textarea" minlength="1" maxlength="255"></b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="Tipo de documento">
                  <multiselect v-model="person_function.resolution_type_id"
                               :options="resolution_types.map(type => type.id)"
                               :custom-label="opt => resolution_types.find(x => x.id === opt).name"
                               placeholder="Seleccione tipo de resolución"
                               selectLabel="Presione para seleccionar"
                               selectedLabel="Seleccionado"
                               deselectLabel="Presione para deseleccionar"
                               :allow-empty="true"
                               @input="generateName">
                    <template v-slot:noOptions>
                      No existen datos
                    </template>
                    <span slot="noResult">
                        No se encontraron elementos.
                    </span>
                  </multiselect>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Número de documento">
                  <ValidationProvider rules="integer|positive" v-slot="{ errors }">
                    <b-input v-model="person_function.resolution" type="text" @input="generateName"></b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Fecha de documento">
                  <b-datepicker
                      v-model="person_function.resolution_date"
                      icon="calendar-alt"
                      trap-focus
                      locale="es-ES"
                      editable
                      placeholder="Formato de Fecha: dd/mm/aaaa"
                      @input="generateName"
                  >
                  </b-datepicker>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="Fecha libera función*">
                  <ValidationProvider rules="required" v-slot="{errors}">
                    <b-datepicker
                        v-model="person_function.start_date"
                        icon="calendar-alt"
                        trap-focus
                        locale="es-ES"
                        :min-date="function_start_date"
                        editable
                        placeholder="Formato de Fecha: dd/mm/aaaa"
                        @input="generateName"

                    >
                    </b-datepicker>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
            </div>
<!--            <div class="columns">
              <div class="column">
                <b-field label="Url carpeta documentación Libera Funciones">
                  <ValidationProvider v-slot="{ errors }" rules="max:255">
                    <b-input v-model="person_function.documentation_link" type="text"></b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
            </div>-->
            <div v-if="queryType == 'update'" class="columns">
              <div class="column is-4">
                <b-field label="Nombre del documento">
                  <b-input v-model="document_name_update" type="text" :disabled="true"></b-input>
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="¿Desea cambiar o agregar un archivo?">
                  <b-radio-button v-model="changeFile"
                                  :native-value="true"
                                  type="is-success is-light is-outlined">
                    <b-icon icon="check-circle"></b-icon>
                    <span>Si</span>
                  </b-radio-button>
                  <b-radio-button v-model="changeFile"
                                  :native-value="false"
                                  type="is-danger is-light is-outlined">
                    <b-icon icon="times-circle"></b-icon>
                    <span>No</span>
                  </b-radio-button>
                </b-field>
              </div>
            </div>
            <div v-if="queryType == 'create' || changeFile" class="columns has-text-centered">
              <div class="column">
                <b-field extended label="Archivo PDF (Tamaño max. 25 MB)">
                  <b-upload v-model="file"
                            drag-drop
                            type="is-primary"
                            accept=".pdf"
                            @input="generateName">
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon
                              icon="file-pdf"
                              size="is-large">
                          </b-icon>
                        </p>
                        <p>Arrastra tu PDF o haz click para subir.</p>
                      </div>
                    </section>
                  </b-upload>
                </b-field>
              </div>
            </div>
            <div v-if="queryType == 'create' || changeFile" class="columns tags is-centered">
              <span
                  v-if="file !== null"
                  v-model="file"
                  class="tag is-primary mt-1">
                {{ file.name }}
                <button
                    class="delete is-small"
                    type="button"
                    @click="onDeleteFile"
                ></button>
              </span>
            </div>
            <div v-if="file !== null" class="columns">
              <div class="column">
                <b-field label="Nombre del documento a subir">
                  <b-input disabled v-model="document_name"></b-input>
                </b-field>
              </div>
            </div>
          </section>
        </div>
        <footer class="modal-card-foot actions">
          <div class="field is-grouped is-pulled-right">
            <button class="button" type="button" @click="$emit('close')">Cerrar</button>
            <button class="button is-primary" type="submit">Guardar </button>
          </div>
        </footer>
      </form>
    </ValidationObserver>
    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import axios from "axios"
import moment from "moment";
import EventBus from "../../eventBus";
export default {
  name: "modal_distance_function_form",
  props: [
    'queryType', 'personId', 'id','modalHeader', 'person_function_id', 'function_name', 'unit', 'hours','old_start_date', 'person_name'
  ],
  data(){
    return {
      old_person_function: {},
      person_function: {},
      errores_validacion:{},
      resolution_types: [],
      person_function_type: {},
      isLoading: false,
      function_start_date: null,
      file: null,
      document_name: null,
      changeFile: false,
      document_name_update: null,
      document_id: null,
    }
  },
  created() {
    this.isLoading=true;
    if (this.queryType === "create"){
      this.person_function.person_id = this.personId
      axios
          .get("/person_functions/"+this.person_function_id+"/new_distance.json")
          .then(res => {
            this.resolution_types = res.data["resolution_types"]
            this.person_function_type = res.data["person_function_type"]
            this.person_function.person_function_type_id = res.data["person_function_type"]["id"]
            this.function_start_date = moment(this.old_start_date).add(1,'days')._d
            this.isLoading=false;
          }).catch(error => {
        console.log(error)
        this.isLoading=false;
      })
    }
    else if (this.queryType === 'update'){
      axios
          .get("/person_functions/"+this.id+"/edit_distance.json")
          .then(res => {
            this.person_function = res.data
            this.resolution_types = res.data["resolution_types"]
            this.function_start_date = moment(this.old_start_date).add(1,'days')._d
            if(res.data["start_date"]!==null){
              this.person_function.start_date = new Date(this.formatDate(res.data["start_date"]))
            }
            if(res.data["resolution_date"]!==null){
              this.person_function.resolution_date = new Date(this.formatDate(res.data["resolution_date"]))
            }
            this.document_id =  res.data["document_id"]
            this.document_name_update = res.data["document_name"]
            this.document_name = res.data["document_name"]
            this.isLoading = false;
          }).catch(error => {
        console.log(error)
        this.isLoading=false;
      })
    }
  },
  methods: {
    formatDate(date){
      if (date!=null && date!=="" && date!==undefined){
        return date.replace(/-/g,"/")
      }
      else{
        return ""
      }
    },
    verifyDocument(){
      this.isLoading= true;
      let id = null
      if(this.queryType==="update"){
        id = this.person_function.id
      }
      axios
          .get("/life_record/validate_resolution_number.json", {
            params: {res_number: this.person_function.resolution, query_type: this.queryType,
              entity_type: "person_function", id: id}
          })
          .then(response =>{
            this.saveDistancePersonFunction()
          }).catch(error => {
        console.log(error)
        console.log(error.response)
        console.log(error.response.status)
        if(error.response.status === 409){ //se encuentra
          this.$buefy.dialog.confirm({
            hasIcon: true,
            type: "is-warning",
            title: "Advertencia",
            message: error.response.data["message"],
            confirmText: "Continuar y guardar",
            cancelText: "Cancelar",
            onConfirm: () => this.saveDistancePersonFunction(),
            onCancel: () => this.isLoading = false
          })
        }
        else if(error.response.status === 400){//bad request
          this.errores_validacion = error.response.data
          var elmnt = document.getElementById("app");
          elmnt.scrollIntoView();
          this.$refs.modalDistancePersonFunction.scrollTop = 0;
          this.$buefy.dialog.alert({
            title: 'Error',
            message: 'Hubo errores al agregar el alejamiento de la función, favor revisar formato',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
          this.isLoading=false;
        }
      })
    },
    saveDistancePersonFunction(){
      this.isLoading=true;
      if (this.queryType==="create"){
        if (this.file != null && this.file.name.split(".").at(-1).toLowerCase() !== "pdf") {
          this.file = null;
          this.isLoading = false;
          this.$buefy.dialog.alert({
            message: "Este archivo no tiene formato PDF",
            type: "is-danger",
            hasIcon: true,
          });
          return;
        }
        if (this.file != null && this.file.size > 1024*1024*25) {
          this.file = null;
          this.isLoading = false;
          this.$buefy.dialog.alert({
            message: "El archivo no puede superar el maximo de 25 MB",
            type: "is-danger",
            hasIcon: true,
          });
          return;
        }

        /*if (this.file != null && (this.person_function.resolution_date ==  null || this.person_function.resolution_date ==  undefined) &&
            (this.person_function.resolution == null || this.person_function.resolution == undefined || this.person_function.resolution == '') &&
            (this.person_function.resolution_type_id == null || this.person_function.resolution_type_id == undefined)) {
          this.isLoading = false;
          this.$buefy.dialog.alert({
            message: "Para adjuntar un archivo, debe llenar al menos uno de los campos del documento",
            type: "is-danger",
            hasIcon: true,
          });
          return;
        }*/
        this.person_function.person_id = this.personId;

        // Crea un objeto FormData
        let formData = new FormData();

        // Agrega datos al objeto FormData
        formData.append("person_function", JSON.stringify(this.person_function));
        formData.append("old_person_function_id", this.person_function_id);
        formData.append("file", this.file); // Aquí agregamos el archivo
        formData.append("document_name", this.document_name);

        axios
            .post("/person_functions/"+this.id+"/create-document-distance.json", formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                })
            .then(response =>{
              this.errores_validacion = {};
              this.$buefy.dialog.alert({
                message: 'La función fue liberada con éxito ',
                confirmText: 'Ok'
              })
              this.person_function = {}
              EventBus.$emit('FUNCION_LIBERADA', response.data);
              this.isLoading=false;
              this.errors = [];
              this.$emit('close')
            }).catch(error => {
          this.errores_validacion = error.response.data
          var elmnt = document.getElementById("app");
          elmnt.scrollIntoView();
          this.$refs.modalDistancePersonFunction.scrollTop = 0;
          this.$buefy.dialog.alert({
            title: 'Error',
            message: 'Hubo errores al liberar la función, favor revisar formato',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
          this.isLoading=false;
        })
      }
      else if (this.queryType==="update"){
        if (this.file != null && this.file.name.split(".").at(-1).toLowerCase() !== "pdf") {
          this.file = null;
          this.isLoading = false;
          this.$buefy.dialog.alert({
            message: "Este archivo no tiene formato PDF",
            type: "is-danger",
            hasIcon: true,
          });
          return;
        }
        if (this.file != null && this.file.size > 1024*1024*25) {
          this.file = null;
          this.isLoading = false;
          this.$buefy.dialog.alert({
            message: "El archivo no puede superar el maximo de 25 MB",
            type: "is-danger",
            hasIcon: true,
          });
          return;
        }

        /*if (this.file != null && (this.person_function.resolution_date ==  null || this.person_function.resolution_date ==  undefined) &&
            (this.person_function.resolution == null || this.person_function.resolution == undefined || this.person_function.resolution == '') &&
            (this.person_function.resolution_type_id == null || this.person_function.resolution_type_id == undefined)) {
          this.isLoading = false;
          this.$buefy.dialog.alert({
            message: "Para adjuntar un archivo, debe llenar al menos uno de los campos del documento",
            type: "is-danger",
            hasIcon: true,
          });
          return;
        }*/

        // Crea un objeto FormData
        let formData = new FormData();
        let clean_person_function =  this.deleteData(this.person_function)
        // Agrega datos al objeto FormData
        formData.append("person_function", JSON.stringify(clean_person_function));
        formData.append("old_person_function_id", this.person_function_id);
        formData.append("file", this.file); // Aquí agregamos el archivo
        formData.append("document_name", this.document_name);

        axios
            .put("/person_functions/"+this.person_function.id+"/update-document-distance.json", formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                })
            .then(response =>{
              this.errores_validacion = {};
              this.$buefy.dialog.alert({
                message: 'La función liberada fue editada con éxito ',
                confirmText: 'Ok'
              })
              this.person_unit = {}
              this.isLoading=false;
              this.errors = [];
              this.$emit('close')
            }).catch(error => {
          this.errores_validacion = error.response.data
          var elmnt = document.getElementById("app");
          elmnt.scrollIntoView();
          this.$refs.modalDistancePersonFunction.scrollTop = 0;
          this.$buefy.dialog.alert({
            title: 'Error',
            message: 'Hubo errores al editar la función liberada, favor revisar formato',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
          this.isLoading=false;
        })
      }
    },
    onDeleteFile() {
      this.file = null;
    },
    generateName(){
      var tipo = "LIBERA_FUNCION"
      var centroCosto = ""
      var number = ""
      var date = ""
      var start_date = ""
      var end_date = ""
      var full_name = "-"+this.person_name

      if (this.person_function.resolution_type_id!= null){
        var nombre_tipo = this.resolution_types.find(x => x.id === this.person_function.resolution_type_id).name
        if(nombre_tipo.includes("RESOLUCION")){
          tipo = "RES"
        }
        else if(nombre_tipo.includes("DECRETO")){
          tipo = "DECR"
        }

        //tipo = this.resolution_types.find(x => x.id === this.person_unit.resolution_type_id).name
        //tipo = this.documentTypesNames.find(type => type.id === this.document.document_type_id).initials
      }

      if (this.person_function.unit_id != null){
        centroCosto = "-CC_" + this.units.find(x => x.id == this.person_function.unit_id).cost_center
      }

      if (this.person_function.resolution != null && this.person_function.resolution != ''){
        number = "-N_" + this.person_function.resolution
      }

      if (this.person_function.resolution_date != null){
        date = "-"+("0" + this.person_function.resolution_date.getDate()).slice(-2)
            + "_" + ("0" + (this.person_function.resolution_date.getMonth()+1)).slice(-2)
            + "_" + this.person_function.resolution_date.getFullYear()
      }

      if (this.person_function.start_date != null){
        start_date = "-"+("0" + this.person_function.start_date.getDate()).slice(-2)
            + "_" + ("0" + (this.person_function.start_date.getMonth()+1)).slice(-2)
            + "_" + this.person_function.start_date.getFullYear()
      }

      if ((this.person_function.resolution_date == null || this.person_function.resolution_date == '')  &&
          (this.person_function.resolution == null || this.person_function.resolution == '')){
        this.document_name = tipo +  centroCosto + full_name + start_date + end_date
      }
      else{
        this.document_name = tipo + number + centroCosto + date
      }
    },
    deleteData(person_function){
      delete person_function.resolution_type
      delete person_function.function
      delete person_function.person
      delete person_function.unit
      delete person_function.resolution_types
      delete person_function.document_id
      delete person_function.document_name
      delete person_function.can_edit
      delete person_function.can_view_pdf
      delete person_function.old_start_date
      return person_function
    },

  }
}
</script>